import { LIMITS } from './limits.js';
const BULLET = /^\s*(?:[-*•·‣▪]|\d+[.)])\s+/;
const CHECKED = /^\s*(?:\[[xX✓]\]|☑|✅|✔|✓)\s*/;
const UNCHECKED = /^\s*(?:\[\s?\]|☐|□)\s*/;
const HEADING = /^\s*#{1,6}\s+(.+?)\s*:?\s*$/;
const TRAILING_HEADING = /^\s*(.+?)\s*:\s*$/;
const QTY_PREFIX = /^(\d+(?:[.,]\d+)?)\s*(?:x|×)\s+(.+)$/i;
const QTY_SUFFIX = /^(.+?)\s+(?:x|×)\s*(\d+(?:[.,]\d+)?)$/i;
/**
 * Turn pasted multi-line text into items. Strips bullets, maps `[x]`/`[ ]` to
 * checked state and `# Foo` to sections. Used by the paste-to-add flow and by
 * the MCP server when an agent hands over a blob of text.
 */
export function parseLines(input, options = {}) {
    const { parseQuantity = true, parseSections = true } = options;
    const out = [];
    for (const rawLine of input.split(/\r?\n/)) {
        let line = rawLine.trim();
        if (!line)
            continue;
        if (parseSections) {
            const heading = HEADING.exec(line);
            if (heading?.[1]) {
                out.push({ kind: 'section', text: heading[1].slice(0, LIMITS.itemTextMax) });
                continue;
            }
        }
        let checked = false;
        line = line.replace(BULLET, '');
        if (CHECKED.test(line)) {
            checked = true;
            line = line.replace(CHECKED, '');
        }
        else if (UNCHECKED.test(line)) {
            line = line.replace(UNCHECKED, '');
        }
        line = line.trim();
        if (!line)
            continue;
        if (parseSections && !checked) {
            const trailing = TRAILING_HEADING.exec(line);
            if (trailing?.[1] && !/\s\S+\s\S+\s\S+/.test(trailing[1])) {
                out.push({ kind: 'section', text: trailing[1].slice(0, LIMITS.itemTextMax) });
                continue;
            }
        }
        let quantity;
        if (parseQuantity) {
            const prefix = QTY_PREFIX.exec(line);
            const suffix = prefix ? null : QTY_SUFFIX.exec(line);
            if (prefix?.[1] && prefix[2]) {
                quantity = prefix[1];
                line = prefix[2].trim();
            }
            else if (suffix?.[1] && suffix[2]) {
                quantity = suffix[2];
                line = suffix[1].trim();
            }
        }
        if (!line)
            continue;
        out.push({
            kind: 'item',
            text: line.slice(0, LIMITS.itemTextMax),
            checked: checked || undefined,
            quantity: quantity?.slice(0, LIMITS.quantityMax),
        });
        if (out.length >= LIMITS.itemsPerAddCall)
            break;
    }
    return out;
}
//# sourceMappingURL=parse.js.map